import React, {
  useEffect,
  useState,
  useCallback
} from 'react';

import { useParams } from 'react-router-dom';
import api from '../services/api';
import './ComplaintChat.css';

const ComplaintChat = () => {

  const { complaintId } = useParams();

  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);

  const loadMessages = useCallback(async () => {

    try {

      const res = await api.get(
        `/api/complaints/messages/${complaintId}`
      );

      setMessages(
        res?.data?.data || res?.data || []
      );

    } catch (error) {

      console.error(
        'Error loading messages:',
        error
      );
    }

  }, [complaintId]);

  useEffect(() => {

    loadMessages();

    const interval = setInterval(() => {
      loadMessages();
    }, 5000);

    return () => clearInterval(interval);

  }, [loadMessages]);

  const sendMessage = async () => {

    if (!message.trim()) return;

    setSending(true);

    try {

      await api.post(
        '/api/complaints/messages',
        {
          complaintId: Number(
            complaintId
          ),
          message
        }
      );

      setMessage('');

      await loadMessages();

    } catch (error) {

      console.error(
        'Error sending message:',
        error
      );

    } finally {

      setSending(false);
    }
  };

  return (
    <div className="chat-container">

      <h2>
        Complaint Conversation
      </h2>

      <div className="chat-box">

        {messages.length === 0 ? (

          <div className="empty-chat">
            No messages yet
          </div>

        ) : (

          messages.map((msg) => (

            <div
              key={msg.id}
              className={
                msg.senderRole ===
                'CORPORATOR'
                  ? 'message corporator'
                  : 'message citizen'
              }
            >

              <div>
                {msg.message}
              </div>

              <small>
                {msg.senderRole}
              </small>

            </div>

          ))
        )}

      </div>

      <div className="chat-input">

        <input
          type="text"
          value={message}
          placeholder="Type message..."
          onChange={(e) =>
            setMessage(
              e.target.value
            )
          }
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              sendMessage();
            }
          }}
        />

        <button
          onClick={sendMessage}
          disabled={sending}
        >
          {sending
            ? 'Sending...'
            : 'Send'}
        </button>

      </div>

    </div>
  );
};

export default ComplaintChat;